import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { usePosition } from './position.js';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const breakpoints = {
  mobile: '641px',
  tablette: '1025px',
  desktop: '9999px',
};

document.querySelector(".btn-menu").addEventListener("click", () => {
  document.querySelector("#page-wrapper").classList.toggle("menu-open");
});
document.querySelector(".overlay").addEventListener("click", () => {
    document.querySelector("#page-wrapper").classList.toggle("menu-open");    
});
document.querySelector(".btn-search").addEventListener("click", () => {
  document.querySelector("#page-wrapper").classList.toggle("search-open");    
});

// Initialiser Swiper avec Drupal behaviors
(function (Drupal, once, drupalSettings) {
  Drupal.behaviors.multicoquesDynamicAdapt = {
    attach: function (context, settings) {
      usePosition(breakpoints, 'max');
      //RZ--> Ajout de la hauteur de l'élément dans une variable CSS pour l'animation
      document.querySelectorAll('[data-h]').forEach(h => {
        let height = h.scrollHeight;
        h.style.setProperty('--h', `${height}px`);
      });
    }
  };
  Drupal.behaviors.multicoquesSwiper = {
    attach: function (context, settings) {
      // Chercher SEULEMENT dans le nouveau contenu
      const carousels = context.querySelectorAll('.swiper:not(.swiper-initialized):not(.swiper-media-carousel)');

      carousels.forEach((carousel) => {
        // Marquer comme initialisé
        carousel.classList.add('swiper-initialized');
        let dataClass = Array.from(carousel.classList).find(cls => cls.startsWith('swiper-data-'));
        
        if (!dataClass) return;
        
        dataClass = dataClass.replace('swiper-data-', '');
        const dataArray = dataClass.split('-');
        let breakpoints = {};
        let slidesPerView = 1;
        if(dataArray.length == 3) {
          slidesPerView = parseInt(dataArray[2]);

          breakpoints[1] = {
            slidesPerView: parseInt(dataArray[0]),
          };
          breakpoints[641] = {
            slidesPerView: parseInt(dataArray[1]),
          };
          breakpoints[1025] = {
            slidesPerView: parseInt(dataArray[2]),
          };
        }

        // Défilement automatique : classe `swiper-autoplay` sur le wrapper de
        // la vue, avec un délai optionnel en ms (`swiper-autoplay-5000`).
        const autoplayClass = Array.from(carousel.classList).find(cls => cls.startsWith('swiper-autoplay'));
        let autoplay = false;
        let loop = false;
        let rewind = false;

        if (autoplayClass) {
          const delay = parseInt(autoplayClass.replace('swiper-autoplay', '').replace('-', '')) || 5000;
          autoplay = {
            delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };

          // Swiper a besoin d'au moins deux fois les slides visibles pour
          // boucler ; en dessous on revient au début sans dupliquer de slide.
          const totalSlides = carousel.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
          const maxSlidesPerView = Math.max(
            slidesPerView,
            ...Object.values(breakpoints).map(bp => bp.slidesPerView)
          );
          loop = totalSlides >= maxSlidesPerView * 2;
          rewind = !loop;
        }

        try{
            // Créer l'instance Swiper
            const swiper = new Swiper(carousel, {
              modules: [Autoplay],
              slidesPerView,
              spaceBetween: 24,
              breakpoints,
              autoplay,
              loop,
              rewind,
            });
        } catch (error) {
            console.log('swiper not created');
        }
      });
    }
  };

  // Carrousel média réutilisable (destinations, articles, fiches techniques)
  Drupal.behaviors.multicoquesMediaCarousel = {
    attach: function (context, settings) {
      const mediaCarousels = context.querySelectorAll('.swiper-media-carousel:not(.swiper-initialized)');

      mediaCarousels.forEach((carousel) => {
        // Marquer comme initialisé
        carousel.classList.add('swiper-initialized');

        // Récupérer les éléments de contrôle
        const prevBtn = carousel.querySelector('.media-carousel__btn--prev');
        const nextBtn = carousel.querySelector('.media-carousel__btn--next');
        const pauseBtn = carousel.querySelector('.media-carousel__btn--pause');
        const currentEl = carousel.querySelector('.media-carousel__current');
        const totalEl = carousel.querySelector('.media-carousel__total');
        const fullscreenBtn = carousel.querySelector('.media-carousel__btn--fullscreen');
        const progressBar = carousel.querySelector('.media-carousel__progress');

        // Compter le nombre réel de slides (avant l'initialisation de Swiper)
        const originalSlides = carousel.querySelectorAll('.swiper-wrapper > .swiper-slide');
        const totalSlides = originalSlides.length;

        // Nettoyer les slides : retirer les liens d'édition et ajouter les légendes
        originalSlides.forEach((slide) => {
          const img = slide.querySelector('img');
          if (img) {
            // Récupérer la légende depuis title ou alt
            const caption = img.title || img.alt;
            
            // Retirer le lien parent qui entoure l'image (lien d'édition du média)
            const link = img.closest('a[href*="/media/"][href*="/edit"]');
            if (link) {
              link.replaceWith(img);
            }

            // Ajouter la légende en overlay si elle existe
            if (caption && caption.trim()) {
              // Vérifier si la légende n'existe pas déjà
              if (!slide.querySelector('.media-carousel__caption')) {
                const captionEl = document.createElement('div');
                captionEl.className = 'media-carousel__caption';
                captionEl.textContent = caption.trim();
                slide.appendChild(captionEl);
              }
            }
          }
        });

        try {
          // Créer l'instance Swiper avec autoplay, navigation et pagination
          const swiper = new Swiper(carousel, {
            modules: [Navigation, Autoplay, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: totalSlides > 1, // Activer loop seulement s'il y a plus d'une slide
            autoplay: totalSlides > 1 ? {
              delay: 4000,
              disableOnInteraction: false,
            } : false,
            navigation: {
              prevEl: prevBtn,
              nextEl: nextBtn,
            },
            pagination: progressBar ? {
              el: progressBar,
              type: 'progressbar',
            } : false,
            on: {
              init: function () {
                // Mettre à jour le compteur initial avec le nombre réel
                if (totalEl) {
                  totalEl.textContent = totalSlides;
                }
                if (currentEl) {
                  currentEl.textContent = this.realIndex + 1;
                }
              },
              slideChange: function () {
                // Mettre à jour le compteur à chaque changement de slide
                if (currentEl) {
                  currentEl.textContent = this.realIndex + 1;
                }
              },
            },
          });

          // Gestion du bouton pause/play
          if (pauseBtn) {
            pauseBtn.addEventListener('click', () => {
              if (pauseBtn.classList.contains('is-paused')) {
                // Reprendre l'autoplay
                swiper.autoplay.start();
                pauseBtn.classList.remove('is-paused');
              } else {
                // Mettre en pause
                swiper.autoplay.stop();
                pauseBtn.classList.add('is-paused');
              }
            });
          }

          // Gestion du bouton plein écran - toggle mode fullscreen
          if (fullscreenBtn) {
            fullscreenBtn.addEventListener('click', (e) => {
              e.preventDefault();
              
              // Toggle classes pour le mode plein écran
              carousel.classList.toggle('full-mode-gallery');
              document.documentElement.classList.toggle('has-full-mode-gallery');
              
              // Mettre à jour Swiper après le changement de taille
              setTimeout(() => {
                swiper.update();
              }, 100);
            });
          }

        } catch (error) {
          console.log('Media carousel not created:', error);
        }
      });
    }
  };

  Drupal.behaviors.multicoquesProductGallery = {
    attach: function (context, settings) {
      const products = once('product-gallery', '.catalog-product', context);
      products.forEach((product) => {
        const mainImage = product.querySelector('.medias img');
        if (!mainImage) return;

        const thumbnails = product.querySelectorAll('.complements .field--name-field-medias > .field__item');
        if (!thumbnails.length) return;

        const images = Array.from(thumbnails).map((thumb) => {
          const img = thumb.querySelector('img');
          return img ? { src: img.src, srcset: img.srcset || '', sizes: img.sizes || '', alt: img.alt || '' } : null;
        }).filter(Boolean);

        let currentIndex = 0;
        thumbnails[0]?.classList.add('is-active');

        function setMainImage(index) {
          currentIndex = index;
          const data = images[index];
          if (!data) return;
          mainImage.src = data.src;
          if (data.srcset) mainImage.srcset = data.srcset;
          if (data.sizes) mainImage.sizes = data.sizes;
          mainImage.alt = data.alt || mainImage.alt;
          thumbnails.forEach(t => t.classList.remove('is-active'));
          thumbnails[index]?.classList.add('is-active');
        }

        thumbnails.forEach((thumb, i) => {
          thumb.addEventListener('mouseenter', () => setMainImage(i));
        });

        // --- Lightbox ---
        const overlay = document.createElement('div');
        overlay.className = 'product-lightbox';
        overlay.innerHTML =
          '<button class="product-lightbox__close" aria-label="Fermer">&times;</button>' +
          '<button class="product-lightbox__prev" aria-label="Précédent"><svg viewBox="0 0 24 24" width="32" height="32"><polyline points="15 18 9 12 15 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="product-lightbox__image-wrap"><img class="product-lightbox__img" src="" alt="" /></div>' +
          '<button class="product-lightbox__next" aria-label="Suivant"><svg viewBox="0 0 24 24" width="32" height="32"><polyline points="9 18 15 12 9 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="product-lightbox__counter"></div>';
        document.body.appendChild(overlay);

        const lbImg = overlay.querySelector('.product-lightbox__img');
        const lbCounter = overlay.querySelector('.product-lightbox__counter');
        let lbIndex = 0;

        function showLightbox(index) {
          lbIndex = index;
          const data = images[lbIndex];
          if (!data) return;
          lbImg.src = data.src;
          lbImg.alt = data.alt;
          lbCounter.textContent = (lbIndex + 1) + ' / ' + images.length;
          overlay.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
        }

        function closeLightbox() {
          overlay.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        }

        function navigateLightbox(dir) {
          lbIndex = (lbIndex + dir + images.length) % images.length;
          const data = images[lbIndex];
          if (!data) return;
          lbImg.src = data.src;
          lbImg.alt = data.alt;
          lbCounter.textContent = (lbIndex + 1) + ' / ' + images.length;
          setMainImage(lbIndex);
        }

        mainImage.style.cursor = 'zoom-in';
        mainImage.addEventListener('click', () => showLightbox(currentIndex));

        thumbnails.forEach((thumb, i) => {
          thumb.addEventListener('click', () => showLightbox(i));
        });

        overlay.querySelector('.product-lightbox__close').addEventListener('click', closeLightbox);
        overlay.querySelector('.product-lightbox__prev').addEventListener('click', () => navigateLightbox(-1));
        overlay.querySelector('.product-lightbox__next').addEventListener('click', () => navigateLightbox(1));

        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) closeLightbox();
        });

        document.addEventListener('keydown', (e) => {
          if (!overlay.classList.contains('is-open')) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') navigateLightbox(-1);
          if (e.key === 'ArrowRight') navigateLightbox(1);
        });
      });
    }
  };

  // Vidéos distantes : l'affiche recouvre le lecteur, qui n'est révélé qu'au
  // clic. C'est le PHP qui dit s'il y a un lecteur (data-video-playable) : on
  // ne peut pas le déduire du DOM, le conteneur tarteaucitron ne recevant son
  // iframe qu'au consentement. Sans lecteur, il ne reste que l'affiche.
  Drupal.behaviors.multicoquesVideoPoster = {
    attach: function (context, settings) {
      once('video-poster', '[data-media-video]', context).forEach((wrapper) => {
        const poster = wrapper.querySelector('.media-video__poster');
        const player = wrapper.querySelector('.media-video__player');
        const playBtn = wrapper.querySelector('.media-video__play');
        if (!poster || !player) return;

        // YouTube répond 404 sur maxresdefault.jpg pour les vidéos jamais
        // publiées en HD : on retombe alors sur hqdefault.jpg.
        const img = poster.querySelector('img[data-poster-fallback]');
        if (img) {
          img.addEventListener('error', function onError() {
            img.removeEventListener('error', onError);
            img.src = img.dataset.posterFallback;
          });
        }

        if (wrapper.dataset.videoPlayable !== '1') {
          wrapper.classList.add('is-unplayable');
          if (playBtn) playBtn.remove();
          return;
        }

        poster.addEventListener('click', () => {
          wrapper.classList.add('is-playing');
        });
      });
    }
  };
  Drupal.behaviors.multicoquesOrderToggle = {
    attach: function (context, settings) {
      // :not(.is-legacy) : une commande reprise de l'ancien site n'a pas de
      // bloc .product-item à déplier, son en-tête ne doit pas être cliquable.
      const headers = once('order-toggle', '.commerce-order-user:not(.is-legacy) .order-header', context);
      headers.forEach((header) => {
        header.style.cursor = 'pointer';
        header.addEventListener('click', (event) => {
          // Un lien de l'en-tête (bouton « Facture ») fait son travail sans
          // déplier le détail.
          if (event.target.closest('a')) {
            return;
          }
          const parent = header.closest('.commerce-order-user');
          parent.classList.toggle('is-open');
        });
      });
    }
  };

  // Menu « Mon compte » en mobile : une rangée d'onglets qui défile à
  // l'horizontale (layout.scss). L'onglet de la page courante peut être hors
  // champ, on fait défiler la rangée jusqu'à lui.
  Drupal.behaviors.multicoquesAccountNavScroll = {
    attach: function (context) {
      once('account-nav-scroll', '.region-sidebar-left nav > ul', context).forEach((list) => {
        const active = list.querySelector('a.is-active');
        if (!active || list.scrollWidth <= list.clientWidth) return;
        list.scrollLeft = active.offsetLeft - list.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
      });
    }
  };

  // Lien « Gestion des cookies » (menu footer, href="#tarteaucitron") : ouvre
  // le panneau tarteaucitron. Sans ce clic intercepté, seul le hashchange natif
  // l'ouvrirait, et une seule fois tant que le hash reste dans l'URL. Si
  // tarteaucitron n'est pas encore chargé, on laisse le hash faire.
  Drupal.behaviors.multicoquesCookiePanel = {
    attach: function () {
      once('cookie-panel', 'html').forEach((root) => {
        root.addEventListener('click', (e) => {
          const link = e.target.closest('a[href$="#tarteaucitron"]');
          if (!link || !window.tarteaucitron?.userInterface) return;
          e.preventDefault();
          window.tarteaucitron.userInterface.openPanel();
        });
      });
    }
  };
})(Drupal, once, drupalSettings);

window.clickArticleResume = (event, link) => {
	if (event.target.closest('a')) return;
	if (event.ctrlKey) {
		window.open(link);
	} else {
		window.location.href = link;
	}
};